var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"decompte"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.afficher && _vm.chiffre)?_c('div',{staticClass:"chiffre"},[_vm._v(_vm._s(_vm.chiffre))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }